const Request = require('@/repositories/request')

class SkillsValidations extends Request {
  findToAssignmentId(assignmentId) {
    return this.$strapi.$http.$get(
      `/skills-validations/by-assignment-id/${assignmentId}`
    )
  }

  findSkillsValidatedDetailBySupervisorAssignmentId(assignmentId) {
    return this.$strapi.$http.$get(
      `/skills-validations/skills-validated-detail/${assignmentId}`
    )
  }

  update(id, data) {
    return this.$strapi['$skills-validations'].update(id, data)
  }
}

module.exports = SkillsValidations
